module.exports = __webpack_public_path__ + "static/img/4.4fe1c6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/4.png
// module id = mddY
// module chunks = 0